import React from "react";
import styled from "styled-components";
import logo from "./logo.png";

const Logo = () => {
  const styleObj = {
    color: "#f8f8f8",
    textAlign: "left",
  };

  return (
    <>
      <div>
        <StyledImage src={logo} alt='Remarque Logo'/>
        <h4 style={styleObj}>DATA & INTEGRATION HUB</h4>
      </div>
    </>
  );
};

export default Logo;

const StyledImage = styled.img`
  padding-top: 10px;
  height: 50px;
`;
